import script from "./WorkspaceNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkspaceNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./WorkspaceNavigation.vue?vue&type=style&index=0&id=1ee85da8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ee85da8"]])

export default __exports__